export const VALIDATE_COUPON_REQUEST = 'VALIDATE_COUPON_REQUEST';
export const VALIDATE_COUPON_SUCCESS = 'VALIDATE_COUPON_SUCCESS';
export const VALIDATE_COUPON_FAILURE = 'VALIDATE_COUPON_FAILURE';

export const CLEAR_COUPON_ERROR = 'CLEAR_COUPON_ERROR';
